import { useSecondaryColor } from '@vibesites/runtime/react';
import { relativeLuminance } from '../utils/luminance';

/**
 * Tailwind text class for secondary-colored copy.
 * When secondary is light (same 0.55 threshold as getContrastTextColor),
 * fall back to primary so headings stay readable on light surfaces.
 */
export function useSecondaryTextClass(): 'text-secondary' | 'text-primary' {
  const secondary = useSecondaryColor();
  return relativeLuminance(secondary) > 0.55 ? 'text-primary' : 'text-secondary';
}
